import React from 'react';

export const CarIcon = ({
  fill = 'white',
  stroke = '#cccccc',
  width = 20,
  height = 20,
  className,
  style,
  ...rest
}) => {
  const sizeStyle = {
    width,
    height,
    minWidth: width,
    minHeight: height,
    flexShrink: 0,
    ...style,
  };

  return (
    <svg
      viewBox="0 0 680 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={sizeStyle}
      {...rest}
    >
      {/* Main body */}
      <path
        d="M340 28 C385 28 412 42 418 68 L422 112 C423 132 423 288 422 308 L418 352 C412 378 385 392 340 392 C295 392 268 378 262 352 L258 308 C257 288 257 132 258 112 L262 68 C268 42 295 28 340 28 Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="2"
      />

      {/* Hood panel */}
      <path
        d="M340 28 C385 28 412 42 418 68 L422 112 C390 104 290 104 258 112 L262 68 C268 42 295 28 340 28 Z"
        fill="#E8E8E8"
        stroke={stroke}
        strokeWidth="1"
      />

      {/* Trunk panel — white */}
      <path
        d="M422 308 L418 352 C412 378 385 392 340 392 C295 392 268 378 262 352 L258 308 C290 316 390 316 422 308 Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="1"
      />

      {/* Windshield */}
      <path
        d="M398 108 C378 101 302 101 282 108 L276 158 C300 152 380 152 404 158 Z"
        fill="#2C3E50"
      />

      {/* Rear window */}
      <path
        d="M398 312 C378 319 302 319 282 312 L276 262 C300 268 380 268 404 262 Z"
        fill="#2C3E50"
      />

      {/* Roof */}
      <path
        d="M404 158 C380 152 300 152 276 158 L272 262 C300 268 380 268 408 262 Z"
        fill="#F0F0F0"
        stroke={stroke}
        strokeWidth="0.8"
      />

      {/* Door handle left */}
      <rect x="253" y="202" width="7" height="16" rx="2" fill="#323232" />
      {/* Door handle right */}
      <rect x="420" y="202" width="7" height="16" rx="2" fill="#323232" />

      {/* Side mirror left */}
      <path d="M258 120 L244 126 L243 136 L258 133 Z" fill="#dddddd" stroke={stroke} strokeWidth="1" />
      {/* Side mirror right */}
      <path d="M422 120 L436 126 L437 136 L422 133 Z" fill="#dddddd" stroke={stroke} strokeWidth="1" />

      {/* Headlights */}
      <rect x="278" y="30" width="30" height="13" rx="4" fill="#FFF9C4" stroke="#E0C000" strokeWidth="1.5" />
      <rect x="372" y="30" width="30" height="13" rx="4" fill="#FFF9C4" stroke="#E0C000" strokeWidth="1.5" />

      {/* Taillights */}
      <rect x="278" y="377" width="30" height="13" rx="4" fill="#ff3333" stroke="#cc0000" strokeWidth="1.5" />
      <rect x="372" y="377" width="30" height="13" rx="4" fill="#ff3333" stroke="#cc0000" strokeWidth="1.5" />

      {/* Front grille */}
      <rect x="312" y="24" width="56" height="9" rx="3" fill="#555555" stroke="#333333" strokeWidth="1" />
    </svg>
  );
};